import ECDeviceDTO from "src/models/ECDeviceDTO";
import { queryOptions } from "./v4QueryOptions/queryOptions"
import AdminApiService from "src/api/AdminApiService";

export const getAllECDevicesOptions = () => {
    return queryOptions({
        queryKey: ["getAllECDevices"],
        retry: false,
        enabled: true,
        refetchOnWindowFocus: false,
        queryFn: async (q) => {

            let devices: ECDeviceDTO[] = [];
            let hasMoreResults = true;
            let offset = 0;
            while(hasMoreResults){
                const result = await AdminApiService.getAllECDevices(offset, q.signal);
                if (result.size == 0 || result.size == null) {
                    return devices;
                }
                offset += result.size;
                hasMoreResults = result.limitExceeded;
                if (result.items == null) {
                    return devices;
                }
                for (let device of result.items) {
                    if (device == null) {
                        console.warn("skipping EC device result due to being null");
                        continue;
                    }
                    devices.push(device);
                }
            }

            devices.sort((a, b) => {
                const result = a.displayName?.localeCompare(b.displayName ?? '');
                if (result === undefined) {
                    return 0;
                }
                return result;
            });

            return devices;
        }
    });
}